<template lang="pug">
    md-content#login-form.center-panel.md-elevation-1(md-theme="white")
        md-content.md-elevation-1.md-accent.message Укажите новый логин и пароль
        div
            md-field(v-bind:class="{ 'md-invalid': errors.has('password') }")
                label Новый пароль
                md-input(v-model="form.password" name="password" v-validate="'required'" data-vv-name="' '")
                span.md-error(v-show="errors.has('password')") {{ errors.first('password') }}
            md-field(v-bind:class="{ 'md-invalid': errors.has('password_confirm') }")
                label Повторите пароль
                md-input(v-model="form.password_confirm" name="password_confirm" v-validate="'required'" data-vv-name="' '")
                span.md-error(v-show="errors.has('password_confirm')") {{ errors.first('password_confirm') }}

            md-content.md-elevation-1.md-accent.message(v-if="message") {{message}}

            .md-layout.md-gutter.md-alignment-center-right
                .md-layout-item.md-size-50
                    md-button.md-raised.md-primary(v-on:click="submit") Отправить
                .md-layout-item.md-size-50
                    router-link(v-bind:to="{name: 'Login'}") Авторизоваться
</template>
<script>
    export default {
        data() {
            return {
                message: '',
                form: {
                    token: '',
                    password: '',
                    password_confirm: ''
                }
            }
        },
        metaInfo() {
            return {
                title: 'Восстановление пароля'
            }
        },
        created() {
            //устанавливаем небольшой размер центральной панели
            this.$store.commit('setSmallSizePanel');

            if (this.$route.query && this.$route.query.token)
                this.form.token = this.$route.query.token
        },
        methods: {
            submit() {
                this.message = '';
                if (this.form.password !== this.form.password_confirm) {
                    this.message = 'Пароли не совпадают';
                    return;
                }
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    this.$store.dispatch('users/resetPasswordConfirm', this.form).then(r => {
                        if (r) this.message = 'Ваш пароль успешно изменён, вы можете авторизоваться.';
                    });
                });
            }
        }
    }
</script>

<style lang="sass">
    #login-form
        height: auto
        width: 400px
        margin: auto
</style>


// WEBPACK FOOTER //
// ResetPasswordConfirm.vue?b696e6d6